import { createElement } from 'react';
import { Elements } from 'prismic-reactjs'

// -- Function to add unique key to props
const propsWithUniqueKey = (props, key) => {
  return Object.assign(props || {}, { key })
}

// -- HTML Serializer
export const htmlSerializer = (type, element, content, children, key) => {
  const props = {}

  // Strip the 'https://' that prismic automatically adds to links
  if (element?.data?.url === 'https://#') element.data.url = '#'

  const hasLabel = element?.spans?.some((span) => span?.data?.label)

  switch (type) {
    case Elements.paragraph: // Paragraph
      return createElement('p', {
        ...propsWithUniqueKey(props, key),
        className: `${ hasLabel ? 'labeled-child' : '' }`
      }, children);

    default: // Always include a default that returns null
      return null
  }
}

export default {
  htmlSerializer
}
